import { getRequest, postRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import {
  getInvoicesList,
  setAdditionalItemWorkOrderDetails,
  setInvoiceDetails,
  setInvoicePayments,
  setWorkOrderPayments,
  setProjectWorkOrders,
} from "./InvoicesSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";

export const GetInvoicesListApi = (input) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/invoices/listView`, input)
      .then((res) => {
        dispatch(getInvoicesList(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Invoice.GetInvoiceListError"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Invoice.GetInvoiceListError"
    );
  }
};

export const generateInvoiceAPI =
  (invoiceInfo, isAdditionalInvoice) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(
        `api/invoices/generateinvoice-from-workorder`,
        invoiceInfo,
        isAdditionalInvoice
      )
        .then((res) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Estimates.Notification.InvoiceAddedSuccessfully" //Update the message key
          );
          return res?.data;
        })
        .catch((e) => {
          const errorMessage = e?.response?.data?.Message || e?.message;
          dispatch(hideLoader());
          OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
          return false;
        });
    } catch {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Estimates.Notification.Anunexpectederroroccurredwhileaddinginvoice" //Update the message key
      );
      return false;
    }
  };

export const GetInvoiceByIdApi = (invoiceId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/invoices/${invoiceId}`)
      .then((res) => {
        dispatch(setInvoiceDetails(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "WorkOrders.Notification.Anerroroccurredwhileretrievinginvoicedetails" //Update the message key
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrders.Notification.Anerroroccurredwhileretrievinginvoicedetails" //Update the message key
    );
  }
};

export const addPaymentRecordAPI = (paymentInfo) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/invoices/generate-PaymentReceipt`, paymentInfo)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Invoice.Notification.PaymentAddedSuccessfully" //Update the message key
        );
        // dispatch(GetInvoicePaymentsByInvoiceIdApi(invoiceId));
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhileaddingepayment" //Update the message key
    );
    return false;
  }
};
export const GetInvoicePaymentsByInvoiceIdApi = (invoiceId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(
      `api/invoices/GetInvoicePaymentsByInvoiceId?invoiceId=${invoiceId}`
    )
      .then((res) => {
        dispatch(setInvoicePayments(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "InvoicePayment.GetInvoicePaymentsError"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "InvoicePayment.GetInvoicePaymentsError"
    );
  }
};
export const previewInvoiceAPI = (invoiceInfo) => (dispatch) => {
  try {
    const selectedLanguage =
      localStorage.getItem("selectedlanguage") || "en-US";
    dispatch(showLoader());
    return postRequest(
      `api/Pdf/PreviewInvoicePdf?culture=${selectedLanguage}`,
      invoiceInfo
    )
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Invoice.Notification.PdfGeneratedSuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Invoice.Notification.PdfGenerationFailed"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Invoice.Notification.PdfGenerationFailed"
    );
    return false;
  }
};
export const invoicePdfAPI = (invoiceId) => (dispatch) => {
  try {
    const selectedLanguage =
      localStorage.getItem("selectedlanguage") || "en-US";
    dispatch(showLoader());
    return getRequest(
      `api/Pdf/InvoicePdf?invoiceId=${invoiceId}&culture=${selectedLanguage}`
    )
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Invoice.Notification.PdfGeneratedSuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Invoice.Notification.PdfGenerationFailed"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Invoice.Notification.PdfGenerationFailed"
    );
    return false;
  }
};
export const sendInvoiceEmailAPI = (input) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/invoices/SendInvoiceEmail`, input)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Invoice.Notification.EmailSentSuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          e?.response?.data?.Message || e?.message || "",
          "Invoice.Notification.EmailSendFailed"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      e?.message || "",
      "Invoice.Notification.EmailSendFailed"
    );
    return false;
  }
};
export const GetInvoicePaymentsByWorkOrderIdApi =
  (workorderId) => (dispatch) => {
    try {
      dispatch(showLoader());
      getRequest(
        `api/invoices/GetInvoicePaymentsByWorkOrderId?workorderId=${workorderId}`
      )
        .then((res) => {
          dispatch(setWorkOrderPayments(res?.data));
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "InvoicePayment.GetInvoicePaymentsError"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "InvoicePayment.GetInvoicePaymentsError"
      );
    }
  };

export const GetAdditionalitemsWorkOrderApi = (workOrderId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/invoices/GetWorkOrderAdditionalItems/${workOrderId}`)
      .then((res) => {
        dispatch(setAdditionalItemWorkOrderDetails(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorderdetails"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorderdetails"
    );
  }
};

export const GetWorkOrdersByProjectIdApi = (projectId) => async (dispatch) => {
  try {
    dispatch(showLoader());
    const response = await getRequest(
      `api/invoices/GetWorkOrdersByProjectId?projectId=${projectId}`
    );

    dispatch(setProjectWorkOrders(response?.data));
    dispatch(hideLoader());
  } catch (error) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrder.GetWorkOrdersByProjectError"
    );
  }
};
export const getInvoicesListByProjectId = (input, projectId) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(
      `api/Project/GetInvoicesListByProjectId?projectId=${projectId}`,
      input
    )
      .then((res) => {
        dispatch(
          getInvoicesList({
            items: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Invoice.Notification.AnErrorOccurredWhileRetrievingInvoices"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Invoice.Notification.AnErrorOccurredWhileRetrievingInvoices"
    );
  }
};
